import React, { useEffect, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { FaChevronDown, FaChevronUp, FaCheck } from 'react-icons/fa';
import { MarkComandaAsDelivered} from '../../../../../crud/pedidos_api/comandas';
import { MdPrint } from 'react-icons/md';
import {PrintComandaByComandaId} from '../../../../../crud/pedidos_api/comandas';
import './RenderComandas.scss';
import {toast} from 'react-toastify';

interface Comanda {
  comanda_id: number;
  pedido_id: number;
  workstation_id: number;
  local_id: number;
  printed: boolean;
  failed: boolean;
  comandaItems: {
    info: {
      mesa: string;
      type: string;
      garzon: string;
      prioridad: string | null;
    };
    items: { text: string; comment: string }[];
    terminal: {
      state: boolean;
      ip_address: string;
      terminal_id: number;
      terminal_name: string;
    };
  };
  isReady: boolean;
  isDelivered: boolean;
  FailMessage: string | null;
  timestamp: string;
}

interface RenderComandasProps {
  comandas: Comanda[];
  setComandas:any;
}

const RenderComandas: React.FC<RenderComandasProps> = ({ comandas, setComandas }) => {
  const calculateElapsedTime = (timestamp: string) => {
    const createdTime = new Date(timestamp);
    const now = new Date();
    const elapsedMilliseconds = now.getTime() - createdTime.getTime();
    const elapsedMinutes = Math.floor(elapsedMilliseconds / 60000);
    const elapsedSeconds = Math.floor((elapsedMilliseconds % 60000) / 1000);
    return `${elapsedMinutes} min ${elapsedSeconds} sec`;
  };

  const [timers, setTimers] = useState(comandas.map((comanda) => calculateElapsedTime(comanda.timestamp)));
  const [openComandaIndex, setOpenComandaIndex] = useState<number | null>(null); // Track which comanda is open

  useEffect(() => {
    const interval = setInterval(() => {
      setTimers(comandas.map((comanda) => calculateElapsedTime(comanda.timestamp)));
    }, 1000);
    return () => clearInterval(interval);
  }, [comandas]);

  const handleToggleDetails = (index: number) => {
    if (openComandaIndex === index) {
      setOpenComandaIndex(null); // Close if already open
    } else {
      setOpenComandaIndex(index); // Open the clicked comanda
    }
  };


  const handleMarkAsDelivered = (comanda_id: number) => {
    MarkComandaAsDelivered(comanda_id).then((response) => {
      // Update the comandas state
        const updatedComandas = comandas.map((comanda) => {
            if (comanda.comanda_id === comanda_id) {
            return { ...comanda, isDelivered: true };
            }
            return comanda;
        });
        // Update the state
        setComandas(updatedComandas);
        toast.success('Comanda marcada como entregada');
    }).catch((error) => {
      toast.error('Error marcando la comanda como entregada');
    });
  };

  const handlePrintComanda = (comanda_id: number) => {
    PrintComandaByComandaId(comanda_id).then((response) => {
      // Update the comandas state
        toast.success('Comanda enviada a impresión');
    }).catch((error) => {
      toast.error('Error imprimiendo la comanda');
    });
  }

  return (
    <div className="render-comandas-grid">
      {comandas.map((comanda, index) => (
        <Card key={comanda.comanda_id} className="render-comanda-card">
          <Card.Body>
            <div className="card-header">
              <Card.Title>{comanda.comandaItems.terminal.terminal_name}</Card.Title>
              <div className={`status ${comanda.printed ? 'printed' : 'not-printed'}`}>
                {comanda.printed ? 'Impresa' : 'No impresa'}
              </div>
            </div>

            <div className="timer">
              Tiempo transcurrido: {timers[index]}
            </div>

            {/* Show/Hide Details */}
            {openComandaIndex === index && (
              <div className="comanda-items">
                {comanda.comandaItems.items.map((item, itemIndex) => (
                  <div key={itemIndex} className="comanda-item-row">
                    <div className="item-text">{item.text}</div>
                    {item.comment && <div className="item-comment">{item.comment}</div>}
                  </div>
                ))}
              </div>
            )}

            <div className="footer-buttons">
              <Button
                variant="none"
                className="detalle-button"
                onClick={() => handleToggleDetails(index)}
              >
                Detalle {openComandaIndex === index ? <FaChevronUp /> : <FaChevronDown />}
              </Button>


              { !comanda.isDelivered && (
                <Button
                  variant="none"
                  className="delivered-button"
                  onClick={() => handleMarkAsDelivered(comanda.comanda_id)}
                >
                  Marcar como Entregado <FaCheck />
                </Button>
              )}

              <Button variant="none" className="imprimir-button" onClick={() => handlePrintComanda(comanda.comanda_id)}>
                Imprimir <MdPrint />
              </Button>
            </div>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};

export default RenderComandas;
